import type { Notification } from '@witmetrics/utils';
import { sortByCreatedAt } from '@witmetrics/utils/arrays';
import { API } from '@/api';
import { IS_READ_FILTER, PAGE_SIZE } from './constants';

export const classes = {
  icon: 'size-5',
};

export const styles = {
  unread: {
    animationName: 'ring-notification-bell',
    animationDuration: '1.2s',
    animationTimingFunction: 'ease-in-out',
  },
};

export function sortNotifications(notifications: Notification[]) {
  return sortByCreatedAt(notifications).slice(0, PAGE_SIZE);
}

export async function fetchNotifications() {
  // One request to get all notifications, one just to get the count of unread notifications
  const [allNotifications, unreadNotifications] = await Promise.all([
    API.Notifications.fetchNotifications({
      filters: [],
      pagination: { page: 1, pageSize: PAGE_SIZE },
    }),
    API.Notifications.fetchNotifications({
      filters: [IS_READ_FILTER],
      pagination: { page: 1, pageSize: 1 },
    }),
  ]);
  return {
    notifications: allNotifications.results,
    unreadCount: unreadNotifications.pagination.rowCount,
  };
}
